module.exports = __webpack_public_path__ + "static/media/Avenir-Black.9557b515.woff";